package com.veldekar.components.srd.spells

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun DarknessDescription() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Magical darkness spreads from a point you choose within range to fill a 15-foot-radius sphere for the duration. The darkness spreads around corners. A creature with darkvision can't see through this darkness, and nonmagical light can't illuminate it.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If the point you choose is on an object you are holding or one that isn't being worn or carried, the darkness emanates from the object and moves with it. Completely covering the source of the darkness with an opaque object, such as a bowl or a helm, blocks the darkness.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("If any of this spell's area overlaps with an area of light created by a spell of 2nd level or lower, the spell that created the light is dispelled.")
    }
}
